import { VersionUpgrade } from './VersionUpgrade';
export class VersionUpgrade18 extends VersionUpgrade {
    migrateState(state) {
        return state;
    }
}
